import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import MenuDesktopHorizontal from "../components/MenuDesktopHorizontal";
import { FaPlus } from "react-icons/fa";
import { client } from "../client";
import SkeletonBlog from "../components/SkeletonBlog";
import OneProjet from "../components/OneProjet";

const Projets = () => {
  const [allProjets, setAllProjets] = useState(null)

  useEffect(() => {
    client
      .fetch(
        `*[_type == 'projet'] {
          _id,
          dateCreaction,
            linkToBuild,
            description,
            title,
            _updatedAt,
            image,
        } | order(_createdAt desc)`
      )
      .then((data) => {
        setAllProjets(data);
      })
      .catch(console.error);
  })

  return (
    <div className="flex flex-col items-center h-screen w-full relative">
      <div className="flex flex-col relative w-full h-screen pb-20 lg:pb-6 px-8 lg:px-4 items-center max-w-2xl lg:max-w-4xl 2xl:max-w-6xl ecran-2000:max-w-7xl">
        <MenuDesktopHorizontal />
        
        <div className="pt-24 flex-1 lg:pt-6 flex flex-col items-center w-full text-white">
          <div className="flex flex-col items-center w-full space-y-8">
            <span
              className="texte-experience text-4xl relative text-[#82aac1] tracking-tighter font-semibold font-[Yanone Kaffeesatz] after:content-[''] 
              after:absolute after:block after:h-1 after:bg-[#82aac1] 
              after:w-full"
            >
              Projets
            </span>
            <ul className="w-full grid grid-cols-1 gap-5 md:grid-cols-2 pb-14">

              {allProjets !== null
                ? allProjets &&
                  allProjets.map((projet) => (
                    <OneProjet
                      key={projet._id}
                      titre={projet.title}
                      lien={projet.linkToBuild}
                      description={projet.description}
                      mainImage={projet.image}
                      dateCreation={projet.dateCreaction}
                      dateMisAJour={projet._updatedAt}
                    />
                  ))
                : [12, 6, 8, 10, 9, 2].map((_, id) => (
                    <SkeletonBlog key={id} />
                  ))}

              {/* <div className="flex items-center flex-col h-64 w-auto col-span-2">
                <p className="text-lg text-gray-300 italic">Mes projets sont en cours</p>
                <img
                  src={process.env.PUBLIC_URL + "./projet-vide.svg"}
                  className="w-auto h-72"
                  alt="page not found"
                />
              </div> */}
            </ul>
          </div>
        </div>

        {/* footer */}
        <div className="lg:hidden">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Projets;
